import { useQuery } from '@apollo/client/react';

import {
  ADDRESS_SEARCH_DEBOUNCE_MS,
  type AddressSearchInput,
  canSearchByAddress,
} from '@modules/_shared/utils/addressSearch';
import { GET_DUPLICATE_TRANSACTIONS } from '@modules/transactions/transactionQueries';
import { useDebouncedValue } from '@shared/hooks/debounce';

const buildVariables = (addr: AddressSearchInput) => ({
  route: addr.route?.trim(),
  street_number: addr.street_number,
  postcode: addr.postcode,
  locality: addr.locality ?? undefined,
});

export const useDuplicateTransactions = (
  address: AddressSearchInput | null | undefined,
) => {
  const debouncedAddress = useDebouncedValue(
    address,
    ADDRESS_SEARCH_DEBOUNCE_MS,
  );

  const canSearch = canSearchByAddress(debouncedAddress);

  const { data, loading, error } = useQuery(GET_DUPLICATE_TRANSACTIONS, {
    skip: !canSearch,
    variables: canSearch ? buildVariables(debouncedAddress!) : undefined,
    fetchPolicy: 'cache-and-network',
  });

  const isDebouncing =
    address !== debouncedAddress && canSearchByAddress(address);

  return {
    transactions: data?.property_transactions ?? [],
    loading: loading || isDebouncing,
    error,
  };
};
